import Vue from 'vue'
import Icon from 'vue-awesome/components/Icon'
import Icomoon from './assets/moloko-icomoon.json'

Icomoon.icons.forEach(icon => {
    const newIcon = {}
    newIcon[icon.properties.name] = {
        width: 1024,
        height: 1024,
        paths: []
    }
    icon.icon.paths.forEach(path => {
        newIcon[icon.properties.name].paths.push({
            style: '',
            d: path
        })
    })
    Icon.register(newIcon)
})

Vue.component('v-icon', Icon)

export default Icon
